import User from "./User" ;
import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  HotListLeadsRequest extends  DBObject {  private static readonly _ISSCRAPEDDATA: number = 0 ;
  private static readonly _USER: number = 1 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _isScrapedData: boolean = false ;
  private _user: User = null ;
 public constructor ( d3eParams ? : Partial<{isScrapedData: boolean, user: User}> ) {
 super();

this.setIsScrapedData(d3eParams?.isScrapedData ?? false);

this.setUser(d3eParams?.user ?? null);
 }
  public get d3eType (  ) : string {
 return 'HotListLeadsRequest' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get isTransientModel (  ) : boolean {
 return ; 
 }
  public get isScrapedData (  ) : boolean {
 return this._isScrapedData ; 
 }
  public setIsScrapedData ( val : boolean ) : void {
 let isValChanged :boolean=this._isScrapedData !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(HotListLeadsRequest._ISSCRAPEDDATA,this._isScrapedData);

this._isScrapedData=val;

this.fire('isScrapedData',this);
 }
  public get user (  ) : User {
 return this._user ; 
 }
  public setUser ( val : User ) : void {
 let isValChanged :boolean=this._user !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(HotListLeadsRequest._USER,this._user);

this.updateObservable('user',this._user,val);

this._user=val;

this.fire('user',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case HotListLeadsRequest._ISSCRAPEDDATA : {
 return this._isScrapedData ; 
 }

case HotListLeadsRequest._USER : {
 return this._user ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : HotListLeadsRequest {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :HotListLeadsRequest=( dbObj as HotListLeadsRequest );

obj.id=this.id;

obj.setIsScrapedData(this._isScrapedData);

obj.setUser(this._user);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case HotListLeadsRequest._ISSCRAPEDDATA : {
 this.setIsScrapedData(( value as boolean ));
 break; }

case HotListLeadsRequest._USER : {
 this.setUser(( value as User ));
 break; }
 }
 }
 }